var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"familyInfo"},[_c('info-form',{attrs:{"isFamily":"","isEdit":"","personId":_vm.id},on:{"submit-form":_vm.submitForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }